var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ohs-hazard-form"},[_c('form',[_c('radio-input',{attrs:{"options":{
      label: 'Priority',
      radios: _vm.radios.PRIORITY,
      value: _vm.val.priority,
      fullWidth: true,
      inline: true,
      index: _vm.index
    }},model:{value:(_vm.val.priority),callback:function ($$v) {_vm.$set(_vm.val, "priority", $$v)},expression:"val.priority"}}),_vm._v(" "),_c('h3',[_vm._v("Location")]),_vm._v(" "),_c('object-select-input',{attrs:{"options":{
        name: 'locationTemplates',
        objects: _vm.locations,
        objectName: 'location',
        value: '',
        fullWidth: true
      }},on:{"input":function($event){return _vm.updateLocation($event)}}}),_vm._v(" "),_c('textarea-input',{ref:"location",attrs:{"options":{
      name: 'location',
      value: _vm.val.location,
      fullWidth: true
    }},model:{value:(_vm.val.location),callback:function ($$v) {_vm.$set(_vm.val, "location", $$v)},expression:"val.location"}}),_vm._v(" "),_c('h3',[_vm._v("Finding")]),_vm._v(" "),_c('object-select-input',{attrs:{"options":{
        name: 'findingTemplates',
        objects: _vm.findings,
        objectName: 'finding',
        value: '',
        fullWidth: true
      }},on:{"input":function($event){return _vm.updateFinding($event)}}}),_vm._v(" "),_c('textarea-input',{ref:"finding",attrs:{"options":{
      name: 'finding',
      value: _vm.val.finding,
      fullWidth: true
    }},model:{value:(_vm.val.finding),callback:function ($$v) {_vm.$set(_vm.val, "finding", $$v)},expression:"val.finding"}}),_vm._v(" "),_c('h3',[_vm._v("Recommendation")]),_vm._v(" "),_c('textarea-input',{ref:"recommendation",attrs:{"options":{
      name: 'recommendation',
      value: _vm.val.recommendation,
      fullWidth: true
    }},model:{value:(_vm.val.recommendation),callback:function ($$v) {_vm.$set(_vm.val, "recommendation", $$v)},expression:"val.recommendation"}}),_vm._v(" "),_c('radio-input',{attrs:{"options":{
      label: 'Assessment',
      radios: _vm.radios.ASSESSMENT,
      value: _vm.val.assessment,
      fullWidth: true,
      inline: true,
      index: _vm.index
    }},model:{value:(_vm.val.assessment),callback:function ($$v) {_vm.$set(_vm.val, "assessment", $$v)},expression:"val.assessment"}}),_vm._v(" "),_c('radio-input',{attrs:{"options":{
      label: 'Cost Estimate',
      radios: _vm.radios.COST_ESTIMATE,
      value: _vm.val.costEstimate,
      fullWidth: true,
      inline: true,
      index: _vm.index
    }},model:{value:(_vm.val.costEstimate),callback:function ($$v) {_vm.$set(_vm.val, "costEstimate", $$v)},expression:"val.costEstimate"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54eb5588","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/displays/OhsHazardForm.vue
// module id = 1211
// module chunks = 1